import { authToken, teladocApi } from '@td/api';
import { get } from 'lodash';
import {
  Payer
} from '@td/membersupport';
import { camelCase, mapKeys, mapValues } from 'lodash';


const fetchPayers = () => {
  return teladocApi.get('/v4/rte_gateways', {}, authToken.get()).then( ({data}) => {
    return data.rte_gateways.map( g => mapKeys(g, (v, k) => camelCase(k)));
  }).then( (result) => {
    return result.map( r => {
      return Payer({
        display: r.gatewayNm,
        gateway: r.gatewayCd,
        payerCode: r.gatewayCd,
        registrationType: 'REGTYPE_RTE',
      })
    });
  });
}

export default fetchPayers;
